import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { ClipLoader } from "react-spinners";
import { Link } from "react-router-dom";
import { userDetailsToLogin } from "../../../redux/action/auth";
import { notifyError } from "../../../helpers/helpers";

function UserDetails() {
  const dispatch = useDispatch();
  const isLaptop = useMediaQuery({ query: "(max-width: 1400px)" });
  const { loading } = useSelector((state) => state.loading);
  const { otpSessionId } = useSelector((pre) => pre?.newRegisterUser);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");
  const [emailId, setEmailId] = useState("")

  const loginWithName = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      return notifyError("Passwords do not match");
    }
    dispatch(userDetailsToLogin(otpSessionId?.session, name, emailId, password));
  };

  return (
    <div className="auth-from slide-in" style={{ width: isLaptop && "700px" }}>
      <div>
        <div className="flex justify-center ">
          <img
            src="/images/auction-image.png"
            alt="logo"
            className="auction-logo"
          />
        </div>

        <h4 className="margin-0px text-center">Sign Up To Auction System</h4>
        <div className="purple lighten-5 cercle-purple-text p-1 flex mt-1">
          <i className="material-symbols-outlined">info</i>

          <p className="ml-1">
            This is a private access only. This dashboard is only for{" "}
            <b>Authorized Accounts</b>.
          </p>
        </div>

        <div className="mt-1">
          <form className="mt-1 " onSubmit={loginWithName}>
            <div className="input-field-style">
              <span className="material-symbols-outlined primary">person</span>
              <input
                className="browser-default "
                placeholder="Enter your name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="input-field-style">
              <span className="material-symbols-outlined primary">email</span>
              <input
                className="browser-default "
                placeholder="Enter your Email Id"
                type="text"
                value={emailId}
                onChange={(e) => setEmailId(e.target.value)}
                required
              />
            </div>

            <div className="input-field-style">
              <span className="material-symbols-outlined primary ">lock</span>
              <input
                className="browser-default input-field "
                placeholder="Enter your password"
                type={showPassword ? "text" : "password"}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <div
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
                style={{ width: "25px" }}
              >
                {showPassword ? (
                  <AiFillEye className="eye-icon" />
                ) : (
                  <AiFillEyeInvisible className="eye-icon" />
                )}
              </div>
            </div>
            <div className="input-field-style">
              <span className="material-symbols-outlined primary ">lock</span>
              <input
                className="browser-default input-field "
                placeholder="Enter your Confirm password"
                type={showConfirmPassword ? "text" : "password"}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <div
                onClick={() => {
                  setShowConfirmPassword(!showConfirmPassword);
                }}
                style={{ width: "25px" }}
              >
                {showConfirmPassword ? (
                  <AiFillEye className="eye-icon" />
                ) : (
                  <AiFillEyeInvisible className="eye-icon" />
                )}
              </div>
            </div>

            <div className="submit-btn mv-2 column flex align-center ">
              <button
                className="btn full-width mb-1 mt-1 "
                type="submit"
                disabled={!name || !password || !confirmPassword || loading || !emailId}
              >
                {loading ? <ClipLoader color="#fff" size={20} /> : "Sign Up"}
              </button>
            </div>
          </form>
        </div>

        <div className="">
          <p className="semi-bold">
            You have an account?
            <Link to={"/login"}>
              <span className="primary pointer"> Log In</span>
            </Link>{" "}
          </p>
        </div>
      </div>
    </div>
  );
}

export default UserDetails;
